import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    loading: 'idle',
    error: null,
    success: false
};
export var UnsubscribeActionType;
(function (UnsubscribeActionType) {
    UnsubscribeActionType["Unsubscribe"] = "unsubscribe/unsubscribe";
    UnsubscribeActionType["UnsubscribeByKey"] = "unsubscribe/unsubscribeByKey";
})(UnsubscribeActionType || (UnsubscribeActionType = {}));
export const unsubscribe = createAsyncThunk(UnsubscribeActionType.Unsubscribe, ({ customer_id, campaign_id }, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        yield api.postUnsubscribe(customer_id, campaign_id);
        return;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const unsubscribeByKey = createAsyncThunk(UnsubscribeActionType.UnsubscribeByKey, ({ key }, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        yield api.postUnsubscribeByKey(key);
        return;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const unsubscribeSlice = createSlice({
    name: ReducerType.Unsubscribe,
    initialState,
    reducers: {
        resetUnsubscribe: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(unsubscribe.fulfilled, state => {
            state.success = true;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(unsubscribe.pending, state => {
            state.loading = 'pending';
        })
            .addCase(unsubscribe.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        })
            .addCase(unsubscribeByKey.fulfilled, state => {
            state.success = true;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(unsubscribeByKey.pending, state => {
            state.loading = 'pending';
        })
            .addCase(unsubscribeByKey.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetUnsubscribe } = unsubscribeSlice.actions;
export const selectUnsubscribe = (state) => state.Unsubscribe;
export const unsubscribeReducer = unsubscribeSlice.reducer;
